import React, { useState, useRef, useEffect } from 'react';
import FacebookLogin from 'react-facebook-login';
import { getAuthenticate } from '../../services/servicesAuthenticate';
import { UpdateFBIGToken } from '../../services/servicesUpdateFBIGToken';
import LoadScreen from '../../components/loadScreen/loadScreen';
import Toastify from '../../components/Toastify';
import { getIp } from '../../services/servicesGetIp';
import { setToken } from '../../services/auth'
import { useHistory } from 'react-router-dom';
import api from '../../services/apiFacebook';
import Popup from 'reactjs-popup';
import Loading from '../../components/Loading/Loading';
import { DivMain, DivMainPopupVerifyEmail, P } from './StyledLogin';
export default function Login({ login, txtbutton, width }) {

    const history = useHistory()
    const reflogin = useRef();
    const refName = useRef();
    const refEmail = useRef();
    const [loadScreen, setLoadScreen] = useState(true);
    const [popupVerifyEmail, setPopupVerifyEmail] = useState(false);
    const [loginObj, setLoginObj] = useState({
        AccessToken: null,
        Facebook_id: null,
        Email: null,
        Picture: null,
        Cover: null,
        Name: null,
        Ip: null,
        Device: null
    });

    const facebookButtonStyle = {
        borderRadius: '4px',
        width: width ? width : 'fit-content',
        padding: '25px',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px'
    };

    const stylePopupVerifyEmail = {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        background: '#00B9BB',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }

    const permissions = "email,instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement";


    async function saveTokenFacebook(token_access) {
        try {
            const data = await UpdateFBIGToken(token_access);
            localStorage.setItem('acess', true);
            return data;
        } catch (error) {
            console.log(error);
            return 'error';
        }

    }

    async function getAccountsSocials(access_token) {
        try {
            const accounts = await api.get(`me?fields=accounts&access_token=${access_token}`);
            // const instagram = await api.get(`{instagram_id}?fields=instagram_accounts&access_token={token_page_facebook}`);
            localStorage.setItem('accounts', JSON.stringify(accounts.data));
            localStorage.setItem('acess_token', access_token);
            if (accounts)
                return 'sucess';
            else
                return 'error';
        } catch (error) {
            console.log(error);
            return 'error';
        }

    }

    async function loginAuthenticate(obj_login) {
        try {
            // debugger
            if (localStorage.getItem('profileSocial')) {
                const { name, email } = JSON.parse(localStorage.getItem('profileSocial'));
                const token = await getAuthenticate({ ...obj_login, Name: name, Email: email, AccessToken: undefined });
                setToken(token);
            } else {
                const token = await getAuthenticate({ ...obj_login, AccessToken: undefined });
                setToken(token);
            }
            setLoadScreen(false);
            // debugger;
            const accounts = await getAccountsSocials(obj_login.AccessToken);
            if (accounts === 'error')
                Toastify.error('Erro ao pegar contas sociais');
            const saveToken = await saveTokenFacebook(obj_login.AccessToken);
            if (saveToken === 'error')
                Toastify.error('Erro ao salvar token');
            setLoadScreen(true);
            history.push({ pathname: '/app/home' });
        } catch (error) {
            console.log(error)
        }

    }

    const responseFacebook = async (promisseFacebook) => {
        try {
            if (promisseFacebook?.status === "unknown") {
                Toastify.error('Não foi possivel realizar o login com facebook');
                setLoadScreen(true);
                return;
            }
            setLoadScreen(false);
            const Ip = await getIpLocal() || '1';
            const Device = mobileCheck() ? 2 : 1;
            setLoginObj(oldInfo => {
                const data = {
                    ...loginObj,
                    AccessToken: promisseFacebook.accessToken,
                    Name: promisseFacebook.name,
                    Email: promisseFacebook.email,
                    Facebook_id: promisseFacebook.userID,
                    Cover: '',
                    Picture: promisseFacebook.picture.data.url || '',
                    Ip: Ip,
                    Device: Device,
                }
                return data;
            });

        } catch (error) {
            console.log(error);
            setLoadScreen(true);
            Toastify.error('Error não foi possivel realizar o login com facebook');
        }

    }
    async function getIpLocal() {
        try {
            const IP = await getIp();
            if (IP.status === 200)
                return IP.data;
            else
                console.log('Erro ao pegar o IP');
        } catch (error) {
            Toastify.error('Erro não foi possivel pegar o ip');
            console.log('Erro não foi possivel pegar o ip');
            return '1';
        }
    }
    useEffect(() => {
        if (window.location.href.includes('localhost')) {
            loginAuthenticate(
                {
                    "Facebook_id": "1443087775775880",
                    "Email": "will22_bowser@hotmail.com",
                    "Picture": "https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=1443087775775880&height=50&width=50&ext=1632700925&hash=AeSPT89XO4BZjHd0Uds",
                    "Cover": "", "Name": "Willians Torres", "Ip": "186.205.15.166", "Device": 1
                }
            )
        } else
            if (loginObj.AccessToken !== null) {
                if ((loginObj.Email && loginObj.Name) || localStorage.getItem('profileSocial')) {
                    loginAuthenticate(loginObj)
                    setLoadScreen(false);
                }
                else
                    setPopupVerifyEmail(true);
            }
    }, [loginObj])
    const App = () => {
        return (
            <FacebookLogin
                appId="1880342718894725"
                autoLoad={false}
                fields="name,email,picture"
                returnScopes={true}
                cookie={true}
                // onClick={componentClicked}
                callback={responseFacebook}
                version="11.0"
                // icon="fa-facebook"
                isMobile={true}
                disableMobileRedirect={true}
                scope={permissions}
                textButton={txtbutton}
                buttonStyle={facebookButtonStyle}
                ref={reflogin}
                redirectUri={'https://social.medx.med.br/app/'}
            // onClick={ (event)=>{event.preventDefault();window.FB.login(responseFacebook)}}
            />
        )
    }

    function accessKeyboard() {
        if (refName.current.value !== '' & refEmail.current.value !== '') {
            try {
                setLoadScreen(false);
                localStorage.setItem('profileSocial', JSON.stringify({ name: refName.current.value, email: refEmail.current.value }))
                setLoginObj(oldInfo => {
                    const data = { ...loginObj, Name: refName.current.value, Email: refEmail.current.value }
                    // loginAuthenticate(data);
                    setLoadScreen(true);
                    return data;
                });
            } catch (error) {
                setLoadScreen(true);
                console.log(error);
                Toastify.error('Erro ao realizar o login')
            }
        } else
            Toastify.warning('Preencha os campos por favor');
    }

    return (<DivMain>
        {
            loadScreen ? <App /> : <Loading />
        }
        <Popup open={popupVerifyEmail} onClose={() => setPopupVerifyEmail(false)}
            closeOnDocumentClick={false} contentStyle={stylePopupVerifyEmail}
            closeOnEscape={false} >
            <div>
                <DivMainPopupVerifyEmail>

                    <P>Não foi possível acessar as informações de login. <br /> Para continuar preencha os campos abaixo:</P>
                    <div>
                        <span>Informe seu nome</span>
                        <input
                            placeholder='Nome'
                            type="text" ref={refName}
                            defaultValue={loginObj.Name}
                            onFocus={(event) => event.target.placeholder = ''}
                            onBlur={(event) => event.target.placeholder = 'Nome'}
                            onKeyDown={(event) => event.key === 'Enter' ? accessKeyboard() : ''}
                        />
                    </div>
                    <div>
                        <span>Informe seu email</span>
                        <input
                            placeholder='Email'
                            type="text" ref={refEmail}
                            defaultValue={loginObj.Email}
                            onFocus={(event) => event.target.placeholder = ''}
                            onBlur={(event) => event.target.placeholder = 'Email'}
                            onKeyDown={(event) => event.key === 'Enter' ? accessKeyboard() : ''}
                        />
                    </div>
                    <button onClick={accessKeyboard}> ACESSAR </button>
                </DivMainPopupVerifyEmail></div>
        </Popup>
    </DivMain>

    )

}

function mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
